const state = {
  authority: {
    accountId: null,
    brandInfos: [],
    menus: {},
    workplace: {}
  },
  userDetails: {
    workPlaceId: '',
    loginId: '',
    name: '',
    email: '',
    accountsType: ''
  }
};

const getters = {
  getWorkPlaceId: (state) => {
    return state.userDetails.workPlaceId;
  },
  getLoginId: (state) => {
    return state.userDetails.loginId;
  },
  isOwner: (state) => {
    return state.userDetails.accountsType === 'OWNER';
  },
  isBrandManager: (state) => {
    return state.userDetails.accountsType === 'BRAND_MANAGER';
  },
  isMember: (state) => {
    return state.userDetails.accountsType === 'MEMBER';
  },
  getBrands: (state) => {
    return state.authority.brandInfos;
  },
  isMultiBrand: (state) => {
    return state.authority.brandInfos.length > 1;
  },
  getFirstBrandsId: (state) => {
    return state.authority.brandInfos && state.authority.brandInfos.length > 0 && state.authority.brandInfos[0].id;
  },
  getBrandAuthority: (state) => {
    return state.authority.menus;
  },
  getUserDetails: (state) => {
    return state.userDetails;
  },
  getAccountId: (state) => {
    return state.authority.accountId;
  },
  getWorkplace: () => {
    return state.authority.workplace;
  },
  // <!-- 커스텀 옵션 검색
  getSearchCustomOption: (state) => (brandId, optionName) => {
    let find = false;
    state.authority.brandInfos.find((el) => {
      if (el.id === brandId) {
        el.customOptions.find((option) => {
          if (option.definitionName === optionName) find = true;
        });
      }
    });
    return find;
  },
  getSearchCustomOptionObj: (state) => (brandId, optionName) => {
    // 옵션 세부 내용이 담긴 customOptionJson 객체 리턴
    const customOption = state.authority.brandInfos
      .find((el) => Number(el.id) === Number(brandId))
      .customOptions.find((f) => f.definitionName === optionName);
    return customOption ? customOption.customOptionJson : {};
  },
  // 커스텀 옵션 검색  -->
  getBrandInfoByIdAndKey: (state) => (payload) => {
    const { key, brandId } = payload;
    const brand = state.authority.brandInfos.find((brand) => brand.id === brandId);
    return brand[key];
  },
  hasCallAISummaryOption: (state) => {
    // 워크플레이스의 STT 사용여부 대신 (해당 워크플레이스 내의 콜 AI 상담요약 사용하는 경우, STT는 기본적으로 사용하는 워크플레이스로 간주)
    // TODO: 추후에 STT 사용여부가 분리되면 해당 내용 변경 필요
    return !!state.authority.brandInfos.find((brand) =>
      brand.customOptions.find((option) => option.definitionName === 'AI' && option.customOptionJson.useCallSummary === true)
    );
  },
  hasChatAISummaryOption: (state) => {
    // MARK: 톡 상담데스크 진입 시 톡 AI 상담요약 사용하는 브랜드 있는 워크플레이스의 경우 AI 상담요약 완료된 keys 조회 하는 API 요청하기 위한 flag
    return !!state.authority.brandInfos.find((brand) =>
      brand.customOptions.find((option) => option.definitionName === 'AI' && option.customOptionJson.useChatSummary === true)
    );
  }
};

const mutations = {
  setAgentAuthority(state, authorityData) {
    state.authority = authorityData;
  },
  setUserDetails(state, userData) {
    state.userDetails = userData;
  },
  setBrandInfoByIdAndKey(state, payload) {
    const { key, brandId, value } = payload;
    const brandIdList = state.authority.brandInfos.map((brand) => brand.id);
    const brandIndex = brandIdList.indexOf(brandId);
    state.authority.brandInfos[brandIndex][key] = value;
  }
};
const actions = {
  async getMyMenu(context, { http, catchCallback }) {
    try {
      const rs = await http({
        method: 'GET',
        url: '/api/v1/my/menus'
      });

      let res = rs.data;
      localStorage.setItem('agent-authority', JSON.stringify(res));

      context.commit('setAgentAuthority', res);
      await Promise.resolve();
    } catch (e) {
      catchCallback();
      await Promise.reject(e);
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/workplace/index.js